import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebaseConfig';
import './ForgotPassword.css';
import './Login.css';
import './Modal.css';
import './ContactModal.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      // Firebase'in sendPasswordResetEmail fonksiyonu
      // Otomatik olarak kullanıcıya şifre sıfırlama linki gönderir
      // Firebase'in default ayarlarını kullan (authorized domains sorunu için)
      await sendPasswordResetEmail(auth, email);
      
      console.log('✅ Şifre sıfırlama e-postası başarıyla gönderildi:', email);
      console.log('⚠️ E-posta gelmiyorsa:');
      console.log('  1. Spam/Gereksiz klasörünü kontrol edin');
      console.log('  2. Firebase Console → Authentication → Email Templates kontrol edin');
      console.log('  3. Firebase\'de "noreply@hops-3.firebaseapp.com" adresinden gelecek');

      setMessage('✅ Şifre sıfırlama linki e-posta adresinize gönderildi. Lütfen e-postanızı kontrol edin.');
      setEmail('');
      
      // 3 saniye sonra login sayfasına yönlendir
      setTimeout(() => {
        navigate('/');
      }, 3000);

    } catch (error) {
      console.error('Şifre sıfırlama hatası:', error);
      
      // Kullanıcı dostu hata mesajları
      let errorMessage = '';
      switch (error.code) {
        case 'auth/user-not-found':
          errorMessage = 'Bu e-posta adresi ile kayıtlı kullanıcı bulunamadı.';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Geçersiz e-posta adresi.';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Çok fazla deneme yaptınız. Lütfen daha sonra tekrar deneyin.';
          break;
        default:
          errorMessage = 'Bir hata oluştu. Lütfen tekrar deneyin.';
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login-section">
      <div className="wave">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      {/* Logo */}
      <div className="logo-container">
        <h1 className="logo-text" onClick={() => window.location.href = 'https://www.hopssoftware.com'}>Hops Software</h1>
      </div>
      
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <h2>Şifremi Unuttum</h2>
          <p className="forgot-password-description">
            E-posta adresinizi girin, size şifre sıfırlama linki gönderelim.
          </p>

          <form onSubmit={handleResetPassword} className="forgot-password-form">
            <input
              type="email"
              placeholder="E-posta adresiniz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="forgot-password-input"
              disabled={loading}
            />

            <button 
              type="submit" 
              className="forgot-password-button" 
              disabled={loading}
            >
              {loading ? (
                <div className="button-loading">
                  <div className="button-spinner"></div>
                  <span>Gönderiliyor...</span>
                </div>
              ) : (
                'Şifre Sıfırlama Linki Gönder'
              )}
            </button>

            {message && (
              <div className="success-message">
                {message}
              </div>
            )}

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}
          </form>

          <button 
            onClick={() => navigate('/')} 
            className="back-to-login-button"
            disabled={loading}
          >
            ← Giriş Sayfasına Dön
          </button>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="login-footer">
        <div className="footer-content">
          <p>&copy; 2024 Hops Software. Tüm hakları saklıdır.</p>
            <div className="footer-links">
              <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }} className="footer-link">Gizlilik Politikası</a>
              <span className="footer-separator">•</span>
              <a href="#terms" onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }} className="footer-link">Kullanım Şartları</a>
              <span className="footer-separator">•</span>
              <a href="#support" onClick={(e) => { e.preventDefault(); setShowContactModal(true); }} className="footer-link">Destek</a>
            </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div className="legal-modal-overlay" onClick={() => setShowPrivacyModal(false)}>
          <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="legal-modal-close" onClick={() => setShowPrivacyModal(false)}>×</button>
            <div className="legal-modal-body">
              <h2 className="legal-modal-title">Gizlilik Sözleşmesi</h2>
              
              <div className="legal-modal-section">
                <h3>1. Veri Toplama ve Kullanım</h3>
                <p>HOPS olarak, hizmetlerimizi kullanırken sizden toplanan kişisel verilerin gizliliğini korumayı taahhüt ediyoruz. Bu veriler arasında isim, e-posta adresi, telefon numarası ve şirket bilgileri bulunmaktadır.</p>
              </div>
              <div className="legal-modal-section">
                <h3>2. Veri Güvenliği</h3>
                <p>Verileriniz, endüstri standardı güvenlik protokolleri ve şifreleme teknolojileri kullanılarak korunmaktadır. Yetkisiz erişim, değiştirme veya ifşaya karşı uygun güvenlik önlemleri alınmaktadır.</p>
              </div>
              <div className="legal-modal-section">
                <h3>3. Veri Paylaşımı</h3>
                <p>Kişisel verileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmamaktadır. Hizmet sağlayıcılarımızla yapılan veri paylaşımları, gizlilik sözleşmeleri kapsamında gerçekleştirilmektedir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>4. Çerezler ve İzleme</h3>
                <p>Platformumuzda, kullanıcı deneyimini iyileştirmek için çerezler kullanılmaktadır. Bu çerezler, oturum bilgilerini ve kullanıcı tercihlerini saklamak için kullanılır.</p>
              </div>
              <div className="legal-modal-section">
                <h3>5. Kullanıcı Hakları</h3>
                <p>KVKK kapsamında, kişisel verilerinize erişim, düzeltme, silme ve işleme itiraz etme haklarına sahipsiniz. Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.</p>
              </div>
              <div className="legal-modal-contact">
                <h3>İletişim Bilgileri</h3>
                <p>Gizlilik politikamız hakkında sorularınız için:</p>
                <p>E-posta: info@hopssoftware.com</p>
                <p>Telefon: +90 552 464 11 16</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Terms Modal */}
      {showTermsModal && (
        <div className="legal-modal-overlay" onClick={() => setShowTermsModal(false)}>
          <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="legal-modal-close" onClick={() => setShowTermsModal(false)}>×</button>
            <div className="legal-modal-body">
              <h2 className="legal-modal-title">Mesafeli Satış Sözleşmesi</h2>
              
              <div className="legal-modal-section">
                <h3>1. Taraflar</h3>
                <p>İşbu sözleşme, HOPS (bundan sonra SATICI olarak anılacaktır) ile alıcı (bundan sonra ALICI olarak anılacaktır) arasında aşağıdaki şartlar çerçevesinde düzenlenmiştir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>2. Sözleşmenin Konusu</h3>
                <p>İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait platform üzerinden satın aldığı kontör hizmetinin satışı ve teslimi ile ilgili olarak 6502 Sayılı Tüketicinin Korunması Hakkında Kanun hükümleri gereğince tarafların hak ve yükümlülüklerinin belirlenmesidir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>3. Hizmet Bilgileri</h3>
                <p>Satın alınan kontör paketi, dijital bir hizmet olup, ödemenin tamamlanmasını takiben ALICI'nın hesabına otomatik olarak tanımlanacaktır. Kontörler, aktivasyon tarihinden itibaren süresiz olarak geçerlidir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>4. Ödeme ve Teslimat</h3>
                <p>Ödeme, platform üzerinden kredi kartı veya banka kartı ile gerçekleştirilir. Kontörler, ödemenin başarıyla tamamlanmasının ardından anında hesaba tanımlanır. Dijital hizmet olması sebebiyle fiziksel teslimat söz konusu değildir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>5. Cayma Hakkı</h3>
                <p>Dijital içerik/hizmet sunumu niteliğinde olan kontör satışlarında, hizmetin tesliminin/ifasının başladığı an itibarıyla cayma hakkı kullanılamaz. Bu husus 6502 Sayılı Kanun'un 15/1-ğ maddesi uyarınca cayma hakkı istisnası kapsamındadır.</p>
              </div>
              <div className="legal-modal-contact">
                <h3>Satıcı Bilgileri</h3>
                <p>Unvan: TUĞBA HAZAL ÖZKARAASLAN HOPS YAZILIM SİSTEMLERİ TEKNOPARK ŞUBESİ</p>
                <p>Adres: Yeniköy Merkez Mah. Vatan Cad. Teknopark Sitesi Başiskele / Kocaeli</p>
                <p>E-posta: info@hopssoftware.com</p>
                <p>Telefon: +90 552 464 11 16</p>
                <p>MERSİS No: 3888146357 / 154133525540002</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Contact/Support Modal */}
      {showContactModal && (
        <div className="contact-modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="contact-modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="contact-modal-header">
              <div className="contact-modal-header-content">
                <h2 className="contact-modal-title">BİZİ ARAYIN</h2>
                <p className="contact-modal-subtitle">Sizi arayalım ve ihtiyacınız olan çözümü sunalım</p>
              </div>
              <div className="contact-modal-header-right">
                <span className="contact-modal-phone">+90 552 464 11 16</span>
                <button className="contact-modal-close" onClick={() => setShowContactModal(false)}>×</button>
              </div>
            </div>
            <div className="contact-modal-body">
              <form className="contact-modal-form">
                <div className="contact-form-group">
                  <input type="text" placeholder="Adınız Soyadınız" className="contact-form-input" required />
                </div>
                <div className="contact-form-group">
                  <input type="text" placeholder="Firma Adınız" className="contact-form-input" required />
                </div>
                <div className="contact-form-group">
                  <div className="contact-phone-group">
                    <select className="contact-country-code">
                      <option value="+90">+90</option>
                    </select>
                    <input type="tel" placeholder="Telefon Numaranız" className="contact-form-input contact-phone-input" required />
                  </div>
                </div>
                <div className="contact-form-group">
                  <input type="email" placeholder="E-posta Adresiniz" className="contact-form-input" required />
                </div>
                <div className="contact-agreements">
                  <div className="contact-agreement-item">
                    <div className="contact-checkbox-container">
                      <input type="checkbox" className="contact-checkbox" id="forgot-contact-privacy" required />
                      <svg className="contact-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                    <label htmlFor="forgot-contact-privacy" className="contact-agreement-text">
                      Gizlilik sözleşmesini okudum ve kabul ediyorum
                    </label>
                  </div>
                  <div className="contact-agreement-item">
                    <div className="contact-checkbox-container">
                      <input type="checkbox" className="contact-checkbox" id="forgot-contact-commercial" />
                      <svg className="contact-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                    <label htmlFor="forgot-contact-commercial" className="contact-agreement-text">
                      Ticari elektronik ileti almayı kabul ediyorum
                    </label>
                  </div>
                </div>
                <button type="submit" className="contact-submit-button">Gönder</button>
              </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ForgotPassword;

